import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const notificationGroupApi = createApi({
  reducerPath: "notificationGroups",
  baseQuery: fetchBaseQueryWrapper({
    path:
      // TODO: User Story 34420: Update Distribution Group Naming
      // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/34420
      "distributionGroups",
  }),
  endpoints: (build) => ({
    getAllNotificationGroups: build.query({
      query: () => "",
      transformResponse: ({ data }) => data,
    }),
    deleteNotificationGroup: build.mutation({
      query: ({ id }) => ({
        url: `delete/${id}`,
        method: "DELETE",
      }),
    }),
    saveNotificationGroup: build.mutation({
      query: (body) => ({
        url: `save`,
        method: "POST",
        body,
      }),
      transformResponse: ({ data: { data } }) => data,
    }),
  }),
});

export const {
  useGetAllNotificationGroupsQuery,
  useDeleteNotificationGroupMutation,
  useSaveNotificationGroupMutation,
} = notificationGroupApi;
